import { render, staticRenderFns } from "./ViewClientDetails.vue?vue&type=template&id=ade13c64"
import script from "./ViewClientDetails.vue?vue&type=script&lang=js"
export * from "./ViewClientDetails.vue?vue&type=script&lang=js"
import style0 from "./ViewClientDetails.vue?vue&type=style&index=0&id=ade13c64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports